import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';

const Disclaimer = () => {
    return (
        <LegalPageLayout>
            <div className="legal-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10">
                            {/* Breadcrumb */}
                            <nav aria-label="breadcrumb" className="mt-4">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Disclaimer
                                    </li>
                                </ol>
                            </nav>

                            {/* Page Header */}
                            <div className="text-center mb-5">
                                <h1 className="h2 font-weight-bold">Disclaimer</h1>
                                <p className="lead text-muted">Last updated: {new Date().toLocaleDateString()}</p>
                            </div>

                            {/* Content */}
                            <div className="legal-content">
                                <section className="mb-5">
                                    <h2>1. General Disclaimer</h2>
                                    <p>
                                        The information provided on SalesPinch's website and platform is for general informational purposes only. While we strive to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the platform for any purpose.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>2. No Professional Advice</h2>
                                    <p>
                                        The information provided through our services should not be construed as professional advice. SalesPinch is not a legal, financial, or business consulting service. Any reliance you place on such information is therefore strictly at your own risk. We recommend consulting with qualified professionals for specific advice tailored to your situation.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>3. Service Availability</h2>
                                    <p>
                                        We do not guarantee that our services will be available at all times or that they will be free from errors or interruptions. SalesPinch may suspend or discontinue any part of our services at any time without notice. We are not liable for any damages or losses resulting from the unavailability of our services.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>4. Data Accuracy and Reliability</h2>
                                    <p>
                                        While we strive to provide accurate and reliable information, we cannot guarantee the accuracy, completeness, or timeliness of any data processed through our platform. Users are responsible for verifying the accuracy of their data and should not rely solely on our platform for critical business decisions.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>5. Third-Party Content and Links</h2>
                                    <p>
                                        Our platform may contain links to third-party websites or integrate with third-party services. We do not endorse, control, or take responsibility for the content, privacy policies, or practices of any third-party websites or services. Your use of third-party services is at your own risk.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>6. User-Generated Content</h2>
                                    <p>
                                        Users may submit content to our platform. We do not endorse, verify, or take responsibility for user-generated content. Users are solely responsible for the content they submit and any consequences that may result from such submissions.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>7. Performance and Results</h2>
                                    <p>
                                        SalesPinch provides tools and features to help manage leads and sales processes. However, we do not guarantee specific results, sales outcomes, or business performance improvements. Success depends on various factors including user implementation, market conditions, and individual business circumstances.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>8. Security and Data Protection</h2>
                                    <p>
                                        While we implement security measures to protect your data, no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee absolute security of your information. Users should take appropriate measures to protect their own data and credentials.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>9. Limitation of Liability</h2>
                                    <p>
                                        To the fullest extent permitted by applicable law, SalesPinch shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of our services.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>10. Indemnification</h2>
                                    <p>
                                        You agree to indemnify and hold harmless SalesPinch, its officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt arising from your use of our services or violation of our terms of service.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>11. Force Majeure</h2>
                                    <p>
                                        SalesPinch shall not be liable for any failure to perform its obligations where such failure is a result of circumstances beyond our reasonable control, including but not limited to natural disasters, government actions, war, terrorism, riots, fire, labor disputes, or technical failures.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>12. Governing Law</h2>
                                    <p>
                                        This disclaimer shall be governed by and construed in accordance with the laws of the jurisdiction in which SalesPinch operates. Any disputes arising from this disclaimer shall be subject to the exclusive jurisdiction of the courts in that jurisdiction.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>13. Changes to Disclaimer</h2>
                                    <p>
                                        We reserve the right to modify this disclaimer at any time. Changes will be effective immediately upon posting on our platform. Your continued use of our services after such changes constitutes acceptance of the updated disclaimer.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>14. Severability</h2>
                                    <p>
                                        If any provision of this disclaimer is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary so that this disclaimer will otherwise remain in full force and effect.
                                    </p>
                                </section>

                                <section className="mb-5">
                                    <h2>15. Contact Information</h2>
                                    <p>
                                        If you have any questions about this disclaimer, please contact us at:
                                    </p>
                                    <div className="contact-info">
                                        <p><strong>Email:</strong> legal@salespinch.com</p>
                                        <p><strong>Address:</strong> 123 Business Street, Suite 100, City, State 12345</p>
                                    </div>
                                </section>

                                <div className="alert alert-info mt-4">
                                    <h4>Important Notice</h4>
                                    <p className="mb-0">
                                        This disclaimer is part of our Terms of Service. By using SalesPinch, you acknowledge that you have read, understood, and agree to be bound by this disclaimer and our Terms of Service.
                                    </p>
                                </div>
                            </div>

                            {/* Footer Links */}
                            <div className="text-center mt-5 pt-4 border-top">
                                <div className="row">
                                    <div className="col-md-4">
                                        <Link to="/terms" className="text-decoration-none">
                                            Terms of Service
                                        </Link>
                                    </div>
                                    <div className="col-md-4">
                                        <Link to="/privacy" className="text-decoration-none">
                                            Privacy Policy
                                        </Link>
                                    </div>
                                    <div className="col-md-4">
                                        <Link to="/contact" className="text-decoration-none">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default Disclaimer; 